module.exports = __webpack_public_path__ + "assets/img/answer.d66e758b.svg";